export default [
  {
    key: 'new_accounts_num',
    name: '新开广告主数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'new_account'
  },
  {
    key: 'new_account_cost',
    name: '新开广告主总消耗',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'new_account',
    minWidth: 180
  }
];
